<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">
            <el-form-item label="标题" prop="name">
                <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="image_id">
                <el-row>
                    <el-button type="primary" @click="openUpload">选择图片</el-button>
                    <div v-if="form.image_id !== ''" class="img">
                        <img :src="file_path" width="100" height="100" />
                    </div>
                </el-row>
            </el-form-item>
            <el-form-item label="链接" prop="sort">
                <div class="d-s-c mb16">
                    <div class="url-box flex-1 d-s-c">
                        <el-input disabled v-model="form.link_url"></el-input>
                    </div>
                    <div class="url-box ml10">
                        <el-button type="primary" @click="changeLink()">选择链接</el-button>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">正常</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        <!--链接选择-->
        <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
    </el-dialog>
</template>

<script>
    import { bannerEdit, bannerDetail } from '@/api/education';
    import Upload from '@/components/file/Upload';
    import Setlink from '@/components/setlink/SetTab';

    export default {
        components: { Upload, Setlink },
        data() {
            return {
                title: '',
                form: {
                    banner_id: 0,
                    category_id: '',
                    title: '',
                    name: '',
                    image_id: '',
                    sort: 1,
                    link_url: '',
                    status: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入广告名称',
                        trigger: 'blur'
                    }],
                    image_id: [{
                        required: true,
                        message: '请上传分类图片',
                        trigger: 'blur'
                    }],
                    sort: [{
                        required: true,
                        message: '分类排序不能为空'
                    }, {
                        type: 'number',
                        message: '分类排序必须为数字'
                    }]
                },

                /*上传图片*/
                isupload: false,

            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加Banner'
                } else {
                    this.title = '编辑Banner'
                    this.form.banner_id = row.banner_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true;
                        bannerEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false;
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false;
                        })
                    }
                })
            },
            getDetail(){
                bannerDetail({id: this.form.banner_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.file_path = result.data.file_path
                })
            },

            // 图片上传
            openUpload(e) {
                // this.type = e;
                this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    this.file_path = e[0].file_path;
                    this.form.image_id = e[0].file_id;
                }
                this.isupload = false;
            },
            /*选择链接*/
            changeLink() {
                this.is_linkset = true;
            },
            /*获取链接并关闭弹窗*/
            closeLinkset(e) {
                this.is_linkset = false;
                this.form.link_url = e ? '/' + e.url : '';
                this.form.name = e.name;
            },
        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/banner/edit.vue